import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";
import { CourseRatingApi } from "./types";

const getByCourseId = (courseId: number): AxiosPromise<GetCourseRatingsSummary> => {
  return api.get<GetCourseRatingsSummary>(endpoints.COURSE_RATINGS.GET_BY_COURSEID(courseId));
};

export const courseRatingsApi = {
  getByCourseId,
};

export interface GetCourseRatingsSummary {
  ratings: CourseRatingApi[];
  average: number;
}
